export const ANALYTICS_EVENTS = {
  AUTH_PAGE_VIEWED: "auth_page_viewed_client",
  AUTH_LOGIN_SUCCESS: "auth_login_success_client",
  AUTH_LOGIN_FAILED: "auth_login_failed_client",
  AUTH_LOGIN_BLOCKED_UNVERIFIED_EMAIL:
    "auth_login_blocked_unverified_email_client",
  AUTH_SIGN_UP_SUCCESS: "auth_sign_up_success_client",
  AUTH_SIGN_UP_FAILED: "auth_sign_up_failed_client",
  AUTH_LOGOUT: "auth_logout_client",
  RESULT_AUTH_TRANSPORT_FAILED: "result_auth_transport_failed_client",
  SERVICE_VISIT: "service_visit_client",

  UI_PROJECT_CREATE_MODAL_OPENED: "ui_project_create_modal_opened_client",
  UI_PROJECT_CREATE_STARTED: "ui_project_create_started_client",
  RESULT_PROJECT_CREATE_SUCCESS: "result_project_create_success_client",
  RESULT_PROJECT_CREATE_FAILED: "result_project_create_failed_client",
  FLOW_PROJECT_FILES_UPLOAD_STARTED: "flow_project_files_upload_started_client",
  RESULT_PROJECT_FILES_UPLOAD_FAILED: "result_project_files_upload_failed_client",
  UI_UPLOAD_BUTTON_CLICKED: "ui_upload_button_clicked_client",
  UI_UPLOAD_FILES_SELECTED: "ui_upload_files_selected_client",
  RESULT_UPLOAD_FILES_REJECTED: "result_upload_files_rejected_client",
  FLOW_UPLOAD_TASK_STARTED: "flow_upload_task_started_client",
  RESULT_UPLOAD_TASK_SUCCESS: "result_upload_task_success_client",
  RESULT_UPLOAD_TASK_FAILED: "result_upload_task_failed_client",
  UI_UPLOAD_TASK_CANCEL_REQUESTED: "ui_upload_task_cancel_requested_client",
  RESULT_UPLOAD_TASK_CANCELLED: "result_upload_task_cancelled_client",
  FLOW_TEXT_TRANSCRIPT_MODAL_OPENED: "flow_text_transcript_modal_opened_client",
  UI_TEXT_TRANSCRIPT_PARSER_CHANGED:
    "ui_text_transcript_parser_changed_client",
  UI_TEXT_TRANSCRIPT_MODE_TOGGLED: "ui_text_transcript_mode_toggled_client",
  RESULT_TEXT_TRANSCRIPT_VALIDATION_FAILED:
    "result_text_transcript_validation_failed_client",
  UI_TEXT_TRANSCRIPT_UPLOAD_STARTED: "ui_text_transcript_upload_started_client",
  RESULT_TEXT_TRANSCRIPT_UPLOAD_SUCCESS:
    "result_text_transcript_upload_success_client",
  RESULT_TEXT_TRANSCRIPT_UPLOAD_FAILED:
    "result_text_transcript_upload_failed_client",
  UI_TEXT_TRANSCRIPT_MODAL_CLOSED: "ui_text_transcript_modal_closed_client",

  UI_INTERVIEW_LINKS_MODAL_OPENED: "ui_interview_links_modal_opened_client",
  UI_INTERVIEW_LINKS_CREATE_STARTED: "ui_interview_links_create_started_client",
  RESULT_INTERVIEW_LINKS_CREATE_SUCCESS:
    "result_interview_links_create_success_client",
  RESULT_INTERVIEW_LINKS_CREATE_FAILED:
    "result_interview_links_create_failed_client",
  UI_INTERVIEW_LINK_COPIED: "ui_interview_link_copied_client",
  UI_INTERVIEW_ROOM_UPDATE_STARTED: "ui_interview_room_update_started_client",
  RESULT_INTERVIEW_ROOM_UPDATE_SUCCESS:
    "result_interview_room_update_success_client",
  RESULT_INTERVIEW_ROOM_UPDATE_FAILED:
    "result_interview_room_update_failed_client",
  UI_INTERVIEW_ROOM_CANCEL_STARTED: "ui_interview_room_cancel_started_client",
  RESULT_INTERVIEW_ROOM_CANCEL_SUCCESS:
    "result_interview_room_cancel_success_client",
  RESULT_INTERVIEW_ROOM_CANCEL_FAILED:
    "result_interview_room_cancel_failed_client",

  UI_RECORD_GENERATE_STARTED: "ui_record_generate_started_client",
  RESULT_RECORD_GENERATE_SUCCESS: "result_record_generate_success_client",
  RESULT_RECORD_GENERATE_FAILED: "result_record_generate_failed_client",
  UI_SINGLE_REPORT_EDIT_STARTED: "ui_single_report_edit_started_client",
  UI_SINGLE_REPORT_EDIT_CANCELLED: "ui_single_report_edit_cancelled_client",
  UI_SINGLE_REPORT_SAVE_STARTED: "ui_single_report_save_started_client",
  RESULT_SINGLE_REPORT_SAVE_SUCCESS: "result_single_report_save_success_client",
  RESULT_SINGLE_REPORT_SAVE_FAILED: "result_single_report_save_failed_client",
  UI_TRANSCRIPT_UTTERANCE_EDIT_STARTED:
    "ui_transcript_utterance_edit_started_client",
  UI_TRANSCRIPT_UTTERANCE_EDIT_SUBMITTED:
    "ui_transcript_utterance_edit_submitted_client",
  RESULT_TRANSCRIPT_UTTERANCE_EDIT_SUCCESS:
    "result_transcript_utterance_edit_success_client",
  RESULT_TRANSCRIPT_UTTERANCE_EDIT_FAILED:
    "result_transcript_utterance_edit_failed_client",
  UI_TRANSCRIPT_UTTERANCE_COPY_CLICKED:
    "ui_transcript_utterance_copy_clicked_client",
  UI_TRANSCRIPT_SPEAKER_RENAME_STARTED:
    "ui_transcript_speaker_rename_started_client",
  RESULT_TRANSCRIPT_SPEAKER_RENAME_SUCCESS:
    "result_transcript_speaker_rename_success_client",
  RESULT_TRANSCRIPT_SPEAKER_RENAME_FAILED:
    "result_transcript_speaker_rename_failed_client",
  UI_TRANSCRIPT_SPEAKER_ASSIGN_STARTED:
    "ui_transcript_speaker_assign_started_client",
  RESULT_TRANSCRIPT_SPEAKER_ASSIGN_SUCCESS:
    "result_transcript_speaker_assign_success_client",
  RESULT_TRANSCRIPT_SPEAKER_ASSIGN_FAILED:
    "result_transcript_speaker_assign_failed_client",
  UI_TRANSCRIPT_SPEAKER_ROLE_TOGGLE_STARTED:
    "ui_transcript_speaker_role_toggle_started_client",
  RESULT_TRANSCRIPT_SPEAKER_ROLE_TOGGLE_SUCCESS:
    "result_transcript_speaker_role_toggle_success_client",
  RESULT_TRANSCRIPT_SPEAKER_ROLE_TOGGLE_FAILED:
    "result_transcript_speaker_role_toggle_failed_client",

  UI_PAYWALL_OPENED: "ui_paywall_opened_client",
  UI_TOKEN_PURCHASE_MODAL_OPENED: "ui_token_purchase_modal_opened_client",
  UI_TOKEN_PURCHASE_MODAL_CLOSED: "ui_token_purchase_modal_closed_client",
  UI_CHECKOUT_STARTED: "ui_checkout_started_client",
  RESULT_CHECKOUT_SUCCESS: "result_checkout_success_client",
  RESULT_CHECKOUT_FAILED: "result_checkout_failed_client",

  UI_BATCH_REPORTS_MODAL_OPENED: "ui_batch_reports_modal_opened_client",
  UI_BATCH_GENERATION_STARTED: "ui_batch_generation_started_client",
  RESULT_BATCH_GENERATION_STARTED: "result_batch_generation_started_client",
  RESULT_BATCH_GENERATION_FAILED: "result_batch_generation_failed_client",

  UI_PROJECT_REPORT_MODAL_OPENED: "ui_project_report_modal_opened_client",
  UI_PROJECT_REPORT_GENERATION_STARTED:
    "ui_project_report_generation_started_client",
  RESULT_PROJECT_REPORT_GENERATION_STARTED:
    "result_project_report_generation_started_client",
  RESULT_PROJECT_REPORT_GENERATION_FAILED:
    "result_project_report_generation_failed_client",
  UI_PROJECT_REPORT_SETUP_SAVE_STARTED:
    "ui_project_report_setup_save_started_client",
  RESULT_PROJECT_REPORT_SETUP_SAVE_SUCCESS:
    "result_project_report_setup_save_success_client",
  RESULT_PROJECT_REPORT_SETUP_SAVE_FAILED:
    "result_project_report_setup_save_failed_client",
  UI_PROJECT_REPORT_CONTENT_EDIT_STARTED:
    "ui_project_report_content_edit_started_client",
  UI_PROJECT_REPORT_CONTENT_EDIT_CANCELLED:
    "ui_project_report_content_edit_cancelled_client",
  UI_PROJECT_REPORT_CONTENT_SAVE_STARTED:
    "ui_project_report_content_save_started_client",
  RESULT_PROJECT_REPORT_CONTENT_SAVE_SUCCESS:
    "result_project_report_content_save_success_client",
  RESULT_PROJECT_REPORT_CONTENT_SAVE_FAILED:
    "result_project_report_content_save_failed_client",
  UI_PROJECT_REPORT_TITLE_EDIT_STARTED:
    "ui_project_report_title_edit_started_client",
  UI_PROJECT_REPORT_TITLE_SAVE_STARTED:
    "ui_project_report_title_save_started_client",
  RESULT_PROJECT_REPORT_TITLE_SAVE_SUCCESS:
    "result_project_report_title_save_success_client",
  RESULT_PROJECT_REPORT_TITLE_SAVE_FAILED:
    "result_project_report_title_save_failed_client",

  UI_AGENT_ACTION_SELECTED: "ui_agent_action_selected_client",
  UI_AGENT_QUERY_SENT: "ui_agent_query_sent_client",
  RESULT_AGENT_QUERY_SUCCESS: "result_agent_query_success_client",
  RESULT_AGENT_QUERY_FAILED: "result_agent_query_failed_client",
  RESULT_AGENT_QUERY_CANCELLED: "result_agent_query_cancelled_client",
  UI_AGENT_SAVE_TO_PROJECT_STARTED: "ui_agent_save_to_project_started_client",
  RESULT_AGENT_SAVE_TO_PROJECT_SUCCESS:
    "result_agent_save_to_project_success_client",
  RESULT_AGENT_SAVE_TO_PROJECT_FAILED:
    "result_agent_save_to_project_failed_client",

  UI_REPORT_SHARE_MODAL_OPENED: "ui_report_share_modal_opened_client",
  UI_REPORT_PUBLIC_LINK_TOGGLE_STARTED:
    "ui_report_public_link_toggle_started_client",
  RESULT_REPORT_PUBLIC_LINK_TOGGLE_SUCCESS:
    "result_report_public_link_toggle_success_client",
  RESULT_REPORT_PUBLIC_LINK_TOGGLE_FAILED:
    "result_report_public_link_toggle_failed_client",
  UI_REPORT_PUBLIC_LINK_COPIED: "ui_report_public_link_copied_client",

  UI_PROJECT_REPORT_SHARE_MODAL_OPENED:
    "ui_project_report_share_modal_opened_client",
  UI_PROJECT_REPORT_PUBLIC_LINK_TOGGLE_STARTED:
    "ui_project_report_public_link_toggle_started_client",
  RESULT_PROJECT_REPORT_PUBLIC_LINK_TOGGLE_SUCCESS:
    "result_project_report_public_link_toggle_success_client",
  RESULT_PROJECT_REPORT_PUBLIC_LINK_TOGGLE_FAILED:
    "result_project_report_public_link_toggle_failed_client",
  UI_PROJECT_REPORT_PUBLIC_LINK_COPIED:
    "ui_project_report_public_link_copied_client",

  UI_RECORD_EXPORT_STARTED: "ui_record_export_started_client",
  RESULT_RECORD_EXPORT_SUCCESS: "result_record_export_success_client",
  RESULT_RECORD_EXPORT_FAILED: "result_record_export_failed_client",
  RESULT_RECORD_DETAIL_TIMEOUT: "result_record_detail_timeout_client",
  UI_PROJECT_REPORT_EXPORT_STARTED: "ui_project_report_export_started_client",
  RESULT_PROJECT_REPORT_EXPORT_SUCCESS:
    "result_project_report_export_success_client",
  RESULT_PROJECT_REPORT_EXPORT_FAILED:
    "result_project_report_export_failed_client",

  UI_REFERRAL_MODAL_OPENED: "ui_referral_modal_opened_client",
  UI_REFERRAL_LINK_COPIED: "ui_referral_link_copied_client",
  RESULT_REFERRAL_LINK_COPY_FAILED: "result_referral_link_copy_failed_client",
  SERVER_ACTION_MISMATCH_DETECTED:
    "server_action_mismatch_detected_client",
  SERVER_ACTION_VERSION_DRIFT_DETECTED:
    "server_action_version_drift_detected_client",
  SERVER_ACTION_PROACTIVE_RELOAD_TRIGGERED:
    "server_action_proactive_reload_triggered_client",
  SERVER_ACTION_RECOVERY_BLOCKED:
    "server_action_recovery_blocked_client",
} as const;
